import config from './config'

/**
 * @readonly
 * @enum {'store' | 'order.id' | 'order.token' | 'city.id' | 'categories.tree' | 'auth.token' | 'auth.user'}
 */
export const keys = {
  STORE: 'store',
  ORDER_ID: 'order.id',
  ORDER_TOKEN: 'order.token',
  CITY_ID: 'city.id',
  CATEGORIES_TREE: 'categories.tree',
  AUTH_TOKEN: 'auth.token',
  AUTH_USER: 'auth.user',
  DELIVERY_METHOD: 'order.delivery_method',
  NEXT_BALANCE_ADJUSTMENT: 'loyalty.balance.next_adjustment',
}

export default {
  _getItem(key, session = false) {
    if (session) {
      return sessionStorage.getItem(`${config.storagePrefix}${key}`)
    }

    return localStorage.getItem(`${config.storagePrefix}${key}`)
  },

  _setItem(key, value, session = false) {
    if (session) {
      sessionStorage.setItem(`${config.storagePrefix}${key}`, value)
    } else {
      localStorage.setItem(`${config.storagePrefix}${key}`, value)
    }

    return this
  },

  _removeItem(key, session = false) {
    if (session) {
      sessionStorage.removeItem(`${config.storagePrefix}${key}`)
    } else {
      localStorage.removeItem(`${config.storagePrefix}${key}`)
    }

    return this
  },

  _getOrSet(key, value = null, remove = false, session = false) {
    if (value === null && remove) {
      return this._removeItem(key, session)
    } else if (value === null) {
      return this._getItem(key, session)
    }

    return this._setItem(key, value, session)
  },

  clearAllBut(but, session = false) {
    Object.values(keys)
      .filter(k => !but.includes(k))
      .forEach(k => this._removeItem(k, session));
  },

  store(value = null, remove = false) {
    return this._getOrSet(keys.STORE, value, remove)
  },

  activeOrderId(value = null, remove = false) {
    return this._getOrSet(keys.ORDER_ID, value, remove)
  },

  activeOrderToken(value = null, remove = false) {
    return this._getOrSet(keys.ORDER_TOKEN, value, remove)
  },

  activeCityId(value = null, remove = false) {
    return this._getOrSet(keys.CITY_ID, value, remove)
  },

  visibleCategoriesTree(value = null, remove = false) {
    return this._getOrSet(keys.CATEGORIES_TREE, value, remove)
  },

  accessToken(value = null, remove = false) {
    return this._getOrSet(keys.AUTH_TOKEN, value, remove)
  },

  user(value = null, remove = false) {
    return this._getOrSet(keys.AUTH_USER, value, remove)
  },

  deliveryMethod(value = null, remove = false) {
    return this._getOrSet(keys.DELIVERY_METHOD, value, remove)
  },

  nextBalanceAdjustment(value = null, remove = false) {
    return this._getOrSet(keys.NEXT_BALANCE_ADJUSTMENT, value, remove)
  },
}
